import React, { FC } from 'react';
import { useTranslation } from '@edreamsodigeo/frontend-core';

import {
  Body,
  Box,
  Button,
  Flex,
  Heading,
  SystemModal,
  SystemModalContent,
  SystemModalHeader,
  SystemModalIcon,
  Glyph,
} from '@edreamsodigeo/prisma-design-system';

type BaseWarningModalProps = {
  open: boolean;
  onClose: () => void;
  onClick: () => void;
  title: string;
  description: string;
  button: string;
  sx?: unknown;
};

const BaseWarningModal: FC<BaseWarningModalProps> = ({
  open,
  onClose,
  onClick,
  title,
  description,
  button,
  sx,
}) => {
  const { t } = useTranslation();

  return (
    <SystemModal open={open} onClose={onClose} sx={sx}>
      <SystemModalHeader type="warning">
        <SystemModalIcon>
          <Glyph category="Alerts" name="Warning" color="orange.70" />
        </SystemModalIcon>
      </SystemModalHeader>
      <SystemModalContent>
        <Flex flexDirection="column" alignItems="center">
          <Heading
            type="2"
            weight="medium"
            textAlign="center"
            color="neutral.90"
          >
            {t(title)}
          </Heading>
          <Box mt="base" mb="1x_big">
            <Body
              type="base"
              weight="normal"
              textAlign="center"
              color="neutral.80"
            >
              {t(description)}
            </Body>
          </Box>
          <Button type="primary" onClick={onClick} size="large">
            {t(button)}
          </Button>
        </Flex>
      </SystemModalContent>
    </SystemModal>
  );
};

export default BaseWarningModal;
